<template>
    <div class="field">
        <label class="label label-blue">
            {{ $t("call-details.users") }}
        </label>
        <div v-if="!anyParticipant">
            <p>{{ $t("call-details.empty-users") }}</p>
        </div>
        <div class="users-container">
            <template v-for="participant in participants">
                <Participant :participant="participant" :key="participant.id" />
            </template>
        </div>
    </div>
</template>

<script>
import Participant from "./Participant";

export default {
    name: "participants",
    components: {
        Participant,
    },
    props: {
        participants: {
            type: Array,
            required: true,
        },
    },
    computed: {
        anyParticipant() {
            return this.participants.length > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.users-container {
    max-height: 25vh;
    overflow-y: auto;
}
</style>